var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import metrics, { MetricsEventType } from '@a0/docs-components/metrics';
import { Divider, DropdownMenu, DropdownMenuList, DropdownMenuListItem, GlobeIcon, IconButton, Label, styled, Tooltip, useDropdownMenuState, } from '@auth0/quantum-product';
import i18next from 'i18next';
import Cookies from 'js-cookie';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
var Root = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            gap: theme.spacing(0.5),
            alignItems: 'center',
            margin: theme.spacing(0, 0, 0, 1.5)
        },
        _b[theme.breakpoints.down('md')] = {
            flexDirection: 'row-reverse',
        },
        _b);
});
var languageOptions = [
    {
        title: 'English (US)',
        id: 'en-us',
    },
    {
        title: 'Français (CA)',
        id: 'fr-ca',
    },
    {
        title: '日本語',
        id: 'ja-jp',
    },
];
export var LanguageMenu = function (props) {
    var _a = useDropdownMenuState({ baseId: 'language-menu' }), triggerProps = _a.triggerProps, menuProps = _a.menuProps;
    var t = useTranslation('core').t;
    var currentLanguage = i18next.language;
    var _b = __read(useState(currentLanguage), 2), selectedLanguage = _b[0], setSelectedLanguage = _b[1];
    languageOptions = languageOptions.filter(function (lang) { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.enabledLanguages) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(lang.id); });
    // Metrics to capture i18n language on application load
    metrics.track(MetricsEventType.LanguageSelectedOnLoad, { lang: currentLanguage });
    useEffect(function () {
        var handleLanguageChanged = function (lng) {
            setSelectedLanguage(lng);
        };
        i18next.on('languageChanged', handleLanguageChanged);
        var queryParams = new URLSearchParams(window.location.search);
        var langParam = queryParams.get('locale');
        if (langParam && langParam !== selectedLanguage) {
            i18next.changeLanguage(langParam);
        }
        return function () {
            i18next.off('languageChanged', handleLanguageChanged);
        };
    }, [selectedLanguage]);
    var handleLanguageChange = function (language) {
        if (language === selectedLanguage)
            return;
        setSelectedLanguage(language);
        Cookies.set('USER_PREFERRED_LOCALE', language);
        localStorage.removeItem('a0_docs_search_token');
        // Metrics to capture i18n language on dropdown change
        metrics.track(MetricsEventType.LanguageSelectedOnChange, { lang: language });
        var _a = window.location, origin = _a.origin, pathname = _a.pathname, search = _a.search;
        var newPathname = pathname;
        // Remove any existing locale from the pathname
        newPathname = newPathname.replace('/docs/fr-ca', '/docs').replace('/docs/ja-jp', '/docs');
        // Add the new locale to the pathname if necessary
        if (language === 'fr-ca') {
            if (!newPathname.includes('/docs/fr-ca')) {
                newPathname = newPathname.replace('/docs', '/docs/fr-ca');
            }
        }
        else if (language === 'ja-jp') {
            if (!newPathname.includes('/docs/ja-jp')) {
                newPathname = newPathname.replace('/docs', '/docs/ja-jp');
            }
        }
        var queryParams = new URLSearchParams(search);
        queryParams.delete('lang');
        var queryString = queryParams.toString();
        var newUrl = queryString ? "".concat(origin).concat(newPathname, "?").concat(queryString) : "".concat(origin).concat(newPathname);
        if (window.location.href !== newUrl) {
            window.location.href = newUrl;
        }
        else {
            window.location.reload();
        }
    };
    return (React.createElement(Root, null,
        React.createElement(Divider, { orientation: "vertical", variant: "middle", flexItem: true }),
        React.createElement(Tooltip, { title: t('pages.homePage.languageChangeTooltip') },
            React.createElement(IconButton, __assign({}, triggerProps),
                React.createElement(GlobeIcon, null))),
        React.createElement(DropdownMenu, __assign({ size: "default", placement: "left", keepMounted: true, maxWidth: 150 }, menuProps),
            React.createElement(DropdownMenuList, null, languageOptions.map(function (_a) {
                var title = _a.title, id = _a.id;
                return (React.createElement(DropdownMenuListItem, { key: id, sx: { '& .QuantumDropdownMenuListItem-content': { flex: 'none' } }, onClick: function (ev) {
                        handleLanguageChange(id);
                        if (menuProps.onClose) {
                            menuProps.onClose(ev, 'itemSelect');
                        }
                    }, selected: selectedLanguage === id, title: title === '日本語' || title === 'Français (CA)' ? (React.createElement(React.Fragment, null,
                        title,
                        ' ',
                        React.createElement(Label, { color: "info", variant: "default", sx: { ml: 0.8, fontSize: '0.65rem', padding: '0.2rem 0.4rem', lineHeight: '1' } },
                            ' ',
                            "Beta",
                            ' '))) : (title) }));
            })))));
};
